import { useEffect, useState } from "react";
import { apiGet, apiPost } from "../api/api";

export default function Formatos() {
  const [formatos, setFormatos] = useState([]);
  const [novoNome, setNovoNome] = useState("");
  const [msg, setMsg] = useState("");

  // ============================
  // 🔄 Carregar formatos
  // ============================
  async function load() {
    try {
      const data = await apiGet("/formatos/");
      setFormatos(data);
    } catch {
      setMsg("Erro ao carregar formatos");
    }
  }

  useEffect(() => {
    load();
  }, []);

  // ============================
  // ➕ Criar formato
  // ============================
  async function criarFormato() {
    if (!novoNome.trim()) {
      setMsg("O nome não pode estar vazio");
      return;
    }

    try {
      await apiPost("/formatos/", { nome: novoNome });
      setNovoNome("");
      setMsg("");
      load();
    } catch {
      setMsg("Erro: formato pode já existir");
    }
  }

  // ============================
  // 🗑 Apagar formato
  // ============================
  async function apagarFormato(id) {
    if (!window.confirm("Tem a certeza que deseja apagar?")) return;

    await fetch(`/api/formatos/${id}`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
    });

    load();
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Gestão de Formatos</h2>

      {msg && <p style={{ color: "red" }}>{msg}</p>}

      {/* Criar formato */}
      <div
        style={{
          marginTop: 20,
          padding: 15,
          background: "#f7f7f7",
          borderRadius: 8,
          width: "100%",
          maxWidth: 400,
        }}
      >
        <h3>Novo Formato</h3>

        <input
          placeholder="Nome do formato"
          value={novoNome}
          onChange={(e) => setNovoNome(e.target.value)}
          style={{ width: "100%", padding: 8 }}
        />

        <button
          onClick={criarFormato}
          style={{
            marginTop: 10,
            padding: "8px 15px",
            background: "#2e7d32",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Criar
        </button>
      </div>

      {/* Listagem */}
      <h3 style={{ marginTop: 30 }}>Formatos existentes</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#ddd" }}>
            <th style={{ padding: 10 }}>ID</th>
            <th style={{ padding: 10 }}>Nome</th>
            <th style={{ padding: 10 }}>Ações</th>
          </tr>
        </thead>

        <tbody>
          {formatos.map((fm) => (
            <tr key={fm.id} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ padding: 10 }}>{fm.id}</td>
              <td style={{ padding: 10 }}>{fm.nome}</td>

              <td style={{ padding: 10 }}>
                <button
                  onClick={() => apagarFormato(fm.id)}
                  style={{
                    padding: "6px 12px",
                    background: "#c62828",
                    color: "white",
                    border: "none",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                >
                  Apagar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}
